// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"33826":"css/editor","96170":"css/app"}[chunkId] + ".css";
};